/*
|--------------------------------------------------------------------------
| Load External
|--------------------------------------------------------------------------
*/

/**
 * Loads external script and initializes app
 */
__gh__webApp.loadExt = function() {

	var commonJS	= __gh__webApp.common;
		commonJS.loadScript({
	    	"src": "//cdn.gatehousemedia.com/assets/1.5.37/ext.global.min.js",
	    	"onload":function(){
		    	__gh__webApp.init();
	    	}
		});
};